export default "/assets/images/raising-hands.7c5595a2c7a31989.png";